module.exports = __webpack_public_path__ + "static/tasklistVG-bd244f36f4d1f9a7d085e8b340aeef66.jpg";